<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="user-main-sidebar" position="left" lockedOpen="gt-md">
        <user-main-sidebar></user-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <input
                            type="text"
                            style="padding:8px;margin:15px auto;width:30%;"
                            placeholder="{{ 'Type to filter users list...'|translate }}"
                            (input)="updateFilter($event)"
                    />
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Worker'|translate}}" prop="firstName">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.firstName}} {{row.lastName}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Username'|translate}}" [width]="70" prop="username"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'E-mail'|translate}}" [width]="70" prop="email"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Phone'|translate}}" prop="phone" [width]="60"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'Cards quantity'|translate}}" prop="cardsQuantity" [width]="40">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a class="nav-link" matRipple routerLink="/customers/cards/{{row.id}}" [routerLinkActive]="[]">
                                    {{row.cardsQuantity}}
                                </a>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'In calendar'|translate}}" [width]="40" prop="cardsQuantity">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.visibleInCalendar">{{'Yes'|translate}}</span>
                                <span *ngIf="!row.visibleInCalendar">{{'No'|translate}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id" [width]="240">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a mat-button color="primary" *appIsGranted="['Workers', 'UPDATE']" routerLink="/users/edit/{{row.id}}">{{'Edit'|translate}}</a>
                                <a mat-button color="primary" *appIsGranted="['Workers', 'READ']" routerLink="/customers/cards/{{row.id}}">{{'Cards'|translate}}</a>
                                <span *ngIf="row.visibleInScheduler">
                                    <a mat-button color="primary" *appIsGranted="['Workers', 'UPDATE']" routerLink="/employee-schedule/{{row.id}}">{{'Grafik'|translate}}</a>
                                </span>
                                <button *appIsGranted="['Workers', 'DELETE']"
                                        mat-button
                                        class="mr-8"
                                        aria-label="Delete"
                                        color="warn"
                                        (click)="showConfirmUserDeleteDialog(row)"
                                >
                                    {{'Delete'|translate}}
                                </button>
                                <a mat-button color="primary" *appIsGranted="['Workers', 'UPDATE']" (click)="showRechargeCardSetup(row)" style="cursor: pointer;">{{'Recharge setup'|translate}}</a> &nbsp;
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
